<template>
  <div class="list">
    <el-row class="tac">
      <el-col>
        <!-- 左侧边栏列表 -->
        <!-- <el-menu class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :default-active="navUrl" router unique-opened v-show="userId ==='1'">
          <component class="menu-item" v-for="(value) in menuList" :key="value.id" :index="value.path" :is="(value.children&&value.children.length>0)?'el-submenu':'el-menu-item'">
            <template slot="title">
              <i :class="[value.icon]"></i>
              <span>{{value.name}}</span>
            </template>
            <template v-if="value.children&&value.children.length>0">
              <el-menu-item class="menu-item" v-for="(v,i) in value.children" :key="v.id+i" :index="v.path">

                <span slot="title">{{v.name}}</span>
              </el-menu-item>
            </template>
          </component>
        </el-menu> -->
        <el-menu default-active="/container/home" class="el-menu-demo" mode="horizontal" router>
          <el-menu-item index="/container/home">
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/container/question">
            <span slot="title">常见问题</span>
          </el-menu-item>

        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navUrl: this.$route.path,
      userId: "",
      listAct: 0,
      menuList: [
        {
          id: 1,
          name: "玩家查询",
          icon: "el-icon-warning",
          path: "yunyinggongju",
          children: [
            {
              id: 4,
              name: "牌局查询",
              icon: "el-icon-warning",
              path: "match",
            },
            {
              id: 5,
              name: "充值查询",
              icon: "el-icon-warning",
              path: "recharge",
            },
          ],
        },
        {
          id: 2,
          name: "俱乐部查询",
          icon: "el-icon-warning",
          path: "shujitongji",
          children: [
            {
              id: 6,
              name: "基本信息",
              icon: "el-icon-warning",
              path: "basicInfo",
            },
            {
              id: 7,
              name: "充值信息",
              icon: "el-icon-warning",
              path: "rechargeInfo",
            },
            {
              id: 8,
              name: "消费信息",
              icon: "el-icon-warning",
              path: "expenseInfo",
            },
            {
              id: 9,
              name: "成员信息",
              icon: "el-icon-warning",
              path: "membersInfo",
            },
          ],
        },
        {
          id: 3,
          name: "账号问题查询",
          icon: "el-icon-warning",
          path: "abnormal",
        },
      ],
      menuList2: [
        {
          id: 1,
          name: "首页",
          path: "home",
        },
        {
          id: 2,
          name: "常见问题",
          path: "question",
        },
      ],
      activeIndex: "1",
    };
  },
  watch: {
    //监听路由变化
    $route(val) {
      //路由如果变化则赋值给初始路由
      this.navUrl = val.path;
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/tabList.vue